import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * `/integrations` index. The section currently has a single page (Connections),
 * so landing on the section root forwards straight to it. Add a real index
 * component here if/when the section grows a dedicated overview again.
 */
// Declares the section-wide subsidiary scope (`sc`) so it can be forwarded through
// the redirect below instead of being dropped on the section root.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // TanStack Router uses throw redirect() as control flow — not an error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/integrations/connections',
      // Carry the picked subsidiary through the hop, or landing on
      // `/integrations?sc=X` would silently reset the scope to the own tenant.
      search: search.sc ? { sc: search.sc } : {},
    });
  },
});
